import Tooltip from "tds/tooltip";

export { Tooltip };

customElements.define("tds-tooltip", Tooltip.CustomElementConstructor);
